"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialScrollToBottom = void 0;
var react_1 = require("react");
/**
 * Hook to scroll to bottom on initial message load, resetting when session changes.
 *
 * @param containerRef - Ref to the scrollable container
 * @param messagesLength - Current number of messages (triggers scroll when > 0)
 * @param sessionId - Session identifier (resets scroll tracking when it changes)
 */
// eslint-disable-next-line import/prefer-default-export
var useInitialScrollToBottom = function (containerRef, messagesLength, sessionId) {
    var hasScrolled = (0, react_1.useRef)(false);
    var scrollToBottom = (0, react_1.useCallback)(function () {
        if (containerRef.current) {
            // eslint-disable-next-line no-param-reassign
            containerRef.current.scrollTop = containerRef.current.scrollHeight;
        }
    }, [containerRef]);
    // Scroll to bottom on initial message load
    (0, react_1.useEffect)(function () {
        if (messagesLength > 0 && !hasScrolled.current) {
            requestAnimationFrame(function () {
                scrollToBottom();
                hasScrolled.current = true;
            });
        }
    }, [messagesLength, scrollToBottom]);
    // Reset when session changes
    (0, react_1.useEffect)(function () {
        hasScrolled.current = false;
    }, [sessionId]);
};
exports.useInitialScrollToBottom = useInitialScrollToBottom;
